import * as React from "react";

class PreviewMoreMessage extends React.Component<{}, {}> {
  public render() {
    return (
      <div className="velaro-preview-message-row">
        <div className="velaro-preview-message velaro-more-notification">
          <a>More...</a>
        </div>
      </div>
    );
  }
}

export default PreviewMoreMessage;
